export function makeItemDataSample(i, count) {
  return {
    // no: i,
    uid: `sample-${i}`,
    avatar: "https://edge-cdn.trakteer.id/images/mix/default-avatar.png",
    supporter_name: `Alias${i}_!!!_Supporter ${i}`,
    // unitIcon: `<img src="https://edge-cdn.trakteer.id/images/mix/cendol.png" width="20px" height="20px">`,
    sum: count,
    // unitName: 'Cendol'
  }
}
export function makeEmptyDataSample() {
  return {
    supporter: [],
    pageUrl: "trakteer.id/chunchunmaru",
    unitName: "Cendol",
    unitIcon: `<img src="https://edge-cdn.trakteer.id/images/mix/cendol.png" width="20px" height="20px">`
  }
}

export async function handlePreview(manager) {
  if (h.isTrue(manager.get('use_placeholder'))) {
    const useNominal = manager.widget.setting['ts_sortby'] == 'nominal';
    let tempItems = []
    for (let i = 1; i <= manager.widget.ts_count(); i++) {
      const count = useNominal ? (manager.widget.ts_count() - i + 1) * 1000 : (manager.widget.ts_count() - i + 1)
      tempItems.push(makeItemDataSample(i, count))
    }

    let params = makeEmptyDataSample();
    params.supporter = tempItems;
    manager.reload(params);
  } else {
    await manager.loadData();
  }
}
